import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AppStore } from '../../store/store';
import { UserState } from '../../store/user.slice';
import { Roles } from '../../utils/roles';

const DefaultRoute = () => {
    const { user } = useSelector<AppStore, UserState>((state) => state.user);
    const target = user?.roles?.includes(Roles.MULTI_MERCHANT_VIEW) ? 'transactions' : 'dashboard';
    return <Navigate to={target} replace />;
};

export default DefaultRoute;
